import { render, staticRenderFns } from "./LoginRecovered.vue?vue&type=template&id=700fe52a"
import script from "./LoginRecovered.vue?vue&type=script&lang=js"
export * from "./LoginRecovered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports